export default { 
	index: { method: 'get', url: 'integration-modules' }, 
}
